import { AEMScenes } from '@as-react/common-types';
import { monetateReducer } from '../../monetate/reducers/MonetateReducer';
import monetateSaga from '../../monetate/sagas/MonetateSagas';
const loadMonetateModule = () => ({
    id: AEMScenes.MONETATE,
    reducerMap: { monetate: monetateReducer },
    sagas: [monetateSaga],
});
export default loadMonetateModule;
